export default __webpack_public_path__ + "static/media/ps-plus.3104b920.svg";